const axios             = require('axios');
import ScrollEvents from './ScrollEvents'
// const ScrollEvents      = require('./ScrollEvents');
//const ToggleScrollBar   = require('./ToggleScrollBar');

const AjaxLoadPage = function()
{
    const $elLoad       = $("#loaderPage");
    const _body         = $("body");
    const _menu         = $("#nav-header");
    const _header       = $("#header");
    const _introLayer   = $("#layerIntroPage");
    const _timerSync    = 800;


    const pageLoader = function() {            
            
        setTimeout(() => {
            _body.removeClass('no-scroll body-content-loading');
            //$elLoad.addClass("motion-in");
            _introLayer.addClass('motion-out');                
            setTimeout(() =>{
                _header.addClass('motion-in');
                ScrollEvents.animeTextIntro("#webdoor-start h2");;
            },500);
        }, _timerSync);

    }

   
    return {
        init : function(status){

            pageLoader();
            

        }
    }

}();

export default AjaxLoadPage;